import axiosInstance from '../axiosInterceptor/axiosInstance'

const updateOrgClub = async (data) => {
  const { orgId, clubId, name, logoDataUri } = data
  const response = await axiosInstance.patch(`v1/orgs/${orgId}/clubs/${clubId}`, {
    name,
    logoDataUri,
  })
  return response?.data
}

export default updateOrgClub
